export default "__VITE_ASSET__4c6dac9c__"